import React, { useEffect, useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { decode } from "he";
import { InputPassword, Button } from "ii-ui-kit";
import { useForm } from "react-hook-form";
import { SubmitHandler } from "react-hook-form/dist/types/form";

import { loginPasswordFormSchema } from "consts";
import { clearFormError } from "utils/clear-form-error/clear-form-error";
import { postForm } from "utils/post-form/post-form";

import { IncorrectPasswordError } from "./incorrect-password-error";
import "./index.scss";

/** Тип, описывающий поля формы ввода пароля  */
export interface ILoginPasswordForm {
  password: string;
}

/** Форма ввода пароля */
export const LoginPasswordPage = () => {
  /** Пользователь N раз ввел неверный пароль и получил блокировку */
  const isUserBlocked = window.error === "invalidUserMessage";

  /** Форма отправляется ? */
  const [isFormSending, setIsFormSending] = useState(false);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<ILoginPasswordForm>({
    mode: "onSubmit",
    resolver: yupResolver(loginPasswordFormSchema),
  });

  const onSubmit: SubmitHandler<ILoginPasswordForm> = (data) => {
    if (window.loginAction) {
      setIsFormSending(true);
      clearFormError();
      postForm(window.loginAction ? decode(window.loginAction) : "", data);
    }
  };

  useEffect(() => {
    if (window.error) {
      setError("password", { message: window.error.trim() });
    }
  }, []);

  return isUserBlocked ? (
    <IncorrectPasswordError />
  ) : (
    <form className={"login-password-page"} onSubmit={handleSubmit(onSubmit)}>
      <div className="login-password-page__title">Вход</div>
      <InputPassword
        addContainerClass={"login-password-page__input"}
        id={"password"}
        label={"Пароль от личного кабинета"}
        placeholder={"Пароль от личного кабинета"}
        form={"formField"}
        errorText={errors["password"]?.message}
        validationStatus={errors["password"] ? "error" : undefined}
        {...register("password")}
        autoFocus
      />
      <div className="login-password-page__dont-remember">
        <a
          href={
            window.loginResetCredentialsUrl
              ? decode(window.loginResetCredentialsUrl)
              : "#"
          }
        >
          Не помню пароль
        </a>
      </div>
      <Button isLoading={isFormSending} title={"Войти"} size={"m"} />
    </form>
  );
};
